import React, { useEffect, useState } from "react"
import * as style from "../styles/LoadingSpinner.module.scss"

export default function LoadingSpinner() {
    return (
        <div className={style.loader} />
    )
}